import UserNotificacionService from "@/api/services/notificacion/UserNotificacionService"
import Vue from "vue"

const state = () => ({
    user_notificaciones: [],

    //notificaciones sin leer del usuario autenticado
    unread_notificaciones: [],
    load_unread_notificaciones: true,
    timer_unread_notificaciones: 30,

    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "id",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    USER_NOTIFICACIONES: state => {
        return state.user_notificaciones
    },

    USER_NOTIFICACIONES_PAG: state => {
        return state.pagination
    },

    USER_UNREAD_NOTIFICACIONES: state => {
        return state.unread_notificaciones
    },

    LOAD_UNREAD_NOTIFICACIONES: state => {
        return state.load_unread_notificaciones
    },

    TIMER_UNREAD_NOTIFICACIONES: state => {
        return state.timer_unread_notificaciones
    }
}

const mutations = {
    SET_USER_NOTIFICACIONES: (state, payload) => {
        state.user_notificaciones = payload
    },

    SET_USER_NOTIFICACIONES_PAG: (state, payload) => {
        state.pagination = payload
    },

    UPDATE_USER_NOTIFICACION: (state, payload) => {
        state.user_notificaciones = state.user_notificaciones.map(el => (el.id === payload.id ? payload : el))
    },

    SET_USER_UNREAD_NOTIFICACIONES: (state, payload) => {
        state.unread_notificaciones = payload
    },

    TOOGLE_LOAD_UNREAD_NOTIFICACIONES: state => {
        state.load_unread_notificaciones = !state.load_unread_notificaciones
    },

    SET_TIMER_UNREAD_NOTIFICACIONES: (state, payload) => {
        state.timer_unread_notificaciones = payload
    }
}

const actions = {
    LOAD_USER_NOTIFICACIONES: async ({ commit, state }, { currentUser, filter, notificacionEstado, customfilter }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }

            let { data, status, headers } = await UserNotificacionService.get({
                currentUser,
                filter,
                customfilter,
                notificacionEstado,
                ...pagination
            })
            if (status === 200) {
                commit("SET_USER_NOTIFICACIONES", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar las notificaciones, inténtelo nuevamente"
            })
        }
    },

    UPDATE_USER_NOTIFICACION: async ({ commit }, payload) => {
        try {
            let { data, status } = await UserNotificacionService.put(payload)
            if (status === 200) {
                commit("UPDATE_USER_NOTIFICACION", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "La notificación ha sido modificada satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar la notificación, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_USER_UNREAD_NOTIFICACIONES: async ({ commit }, currentUser) => {
        try {
            let { data, status } = await UserNotificacionService.getUnreadNotificaciones({ currentUser })
            if (status === 200) {
                commit("SET_USER_UNREAD_NOTIFICACIONES", data)
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar las notificaciones"
            })
        }
    },

    UPDATE_USER_UNREAD_NOTIFICACION: async ({ commit }, payload) => {
        try {
            let { status } = await UserNotificacionService.put(payload)
            if (status === 200) {
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "La notificación ha sido modificada satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar la notificación, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
